import { styled } from "styled-components";

export const MyListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;

  width: 120px;
  height: 150px;
`;
